module.exports = __webpack_public_path__ + "media/images/floor_plan-ac161113.png";